// extracted by mini-css-extract-plugin
export default {"sortingModalTrigger":"jut__SortingModalTrigger__sortingModalTrigger","sortingModalTriggerIcon":"jut__SortingModalTrigger__sortingModalTriggerIcon"};